import React, { useState, useEffect } from 'react';
import api from '../../../utils/api';
import toast from 'react-hot-toast';
import { Link2, RefreshCw } from 'lucide-react';
import { Dialog, TableSkeleton } from '../../../components/ui';

// The subscribe panel, on the app's one accessible dialog (Escape, focus kept inside, labelled).
export default function FeedModal({ open, onClose }) {
  const [feed, setFeed] = useState({ token: null, enabled: false });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get('/support-coordination/calendar-feed').then((r) => setFeed(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [open]);
  const url = feed.token ? `${window.location.origin}/api/sc-public/calendar/${feed.token}.ics` : null;
  const toggle = async (enabled) => { try { const r = await api.put('/support-coordination/calendar-feed', { enabled }); setFeed(r.data); } catch { toast.error('Could not change the calendar feed'); } };
  const rotate = async () => { try { const r = await api.put('/support-coordination/calendar-feed', { enabled: true, rotate: true }); setFeed(r.data); toast.success('New link generated'); } catch { toast.error('Could not generate a new link'); } };
  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success('Feed URL copied'); } catch { toast.error('Copy failed'); } };
  return (
    <Dialog open={open} onClose={onClose} size="sm" title="Subscribe to the calendar"
      description="See appointments, key dates and tasks in Google Calendar, Outlook or your phone’s calendar.">
      {loading ? <TableSkeleton rows={2} cols={2} /> : (
        <div className="space-y-4">
          <label className="flex items-center gap-2.5 text-sm cursor-pointer">
            <input type="checkbox" className="w-4 h-4 rounded" checked={feed.enabled} onChange={(e) => toggle(e.target.checked)} />
            <span className="font-medium text-slate-700">Calendar feed is {feed.enabled ? 'live' : 'off'}</span>
          </label>
          {feed.enabled && url && (
            <>
              <div className="flex items-center gap-2">
                <input readOnly value={url} aria-label="Calendar feed URL" className="input-field !py-1.5 text-xs flex-1 min-w-0" onFocus={(e) => e.target.select()} />
                <button type="button" onClick={copy} className="btn-secondary btn-sm"><Link2 size={13} aria-hidden="true" /> Copy</button>
                <button type="button" onClick={rotate} className="btn-secondary btn-sm" aria-label="Generate a new link" title="Generate a new link"><RefreshCw size={13} /></button>
              </div>
              <p className="text-[11px] text-slate-500">In Google Calendar: <strong>Other calendars → From URL</strong>. In Outlook: <strong>Add calendar → Subscribe from web</strong>. Paste this URL. Updates sync automatically.</p>
            </>
          )}
        </div>
      )}
    </Dialog>
  );
}
